import React from "react"
import styled from "styled-components"

import {
  Container,
  H2,
  P,
  ButtonLink,
  AbsoluteImg,
} from "../general/GeneralStyles"

const Banner = styled.div`
  background: ${props => props.theme.primaryAccentBg};
  position: relative;

  @media (max-width: ${props => props.theme.extraLargeBreakpoint}) and (min-width: ${props => props.theme.mediumBreakpoint}) {
    padding: 0 120px;
  }

`

const RedeemContainer = styled(Container)`
  padding: 56px 0 30px 0;
  margin-bottom: 55px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${P} {
    max-width: 600px;
    font-size: 16px;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    flex-direction: column;
  }

`

const Rocket = styled(AbsoluteImg)`
  left: 2%;
  top: -223px;
  z-index: 1;
  transform: scaleX(-1) scale(.7) rotate(-24deg);
`

const RedClay = styled(AbsoluteImg)`
  bottom: 9%;
  left: 0;
  z-index: 1;
  transform: translate(0, 100%);
`

const YellowClay = styled(AbsoluteImg)`
  top: -12%;
  right: 0;
  z-index: 1;
`

const Coupon = styled(AbsoluteImg)`
  bottom: -50px;
  right: 0;
  z-index: 1;
  /* transform: rotate(20deg); */
`

const RedeemCTA = props => {
  return (
    <Banner>
      {/* Absolute Images */}
      <Rocket src="/images/absolute/clayrocket.png" alt="rocket" />
      <RedClay src="/images/absolute/red-clay.png" alt="red clay" />
      <YellowClay src="/images/absolute/yellow-clay.png" alt="yellow clay" />
      <Coupon src="/images/absolute/coupon.png" alt="coupon" />
      {/* End Absolute Images */}
      <RedeemContainer>
        <div>
          <H2>Redeem Your Points</H2>
          <P>
            Once you have at least 300 points banked in your account, you can
            start ordering FREE products. There is no limit to the number of
            free products you can earn. The more UPC codes you submit, the more
            products you can order. <br /> <strong>It’s that simple!</strong>
          </P>
        </div>
        <ButtonLink to="/login">Redeem My Points</ButtonLink>
      </RedeemContainer>
    </Banner>
  )
}

export default RedeemCTA
